import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  async copy(event) {
    event.preventDefault()

    const text = this.textValue || this.element.getAttribute("href")
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      this.showCopiedState()
    } catch (error) {
      console.warn("Clipboard copy failed", error)
    }
  }

  showCopiedState() {
    const original = this.element.textContent
    this.element.textContent = "Link copied!"
    this.element.classList.add("bg-emerald-100", "text-emerald-700")

    setTimeout(() => {
      this.element.textContent = original
      this.element.classList.remove("bg-emerald-100", "text-emerald-700")
    }, 2000)
  }
}
